import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { faLeaf } from "@fortawesome/free-solid-svg-icons";
import { faImagePortrait } from "@fortawesome/free-solid-svg-icons";

const Services = () => {
	return (
		<section className="op-inScreen text-center my-8">
			<svg
				width="1969"
				height="1247"
				viewBox="0 0 1969 1247"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				className="absolute w-[98vw] h-[60vh] -z-10"
			>
				<g opacity="0.07" clipPath="url(#clip0_8_2)">
					<path d="M1969 0H-9V1247H1969V0Z" fill="white" />
					<path
						d="M1368.52 453.96H1755.51C1782.47 453.96 1804.24 473.683 1804.24 497.917V846.921C1804.24 871.237 1782.39 890.867 1755.51 890.867H1368.52C1341.55 890.867 1319.77 871.154 1319.77 846.921V498C1319.68 473.683 1341.55 453.96 1368.52 453.96Z"
						fill="#8D8D8D"
					/>
					<path
						d="M657.524 602.571H200.186C169.218 602.571 144.184 623.614 144.184 649.646V1010.83C144.184 1036.87 169.218 1057.91 200.186 1057.91H657.524C688.505 1057.91 713.539 1036.87 713.539 1010.83V649.646C713.539 623.698 688.393 602.571 657.524 602.571Z"
						fill="#8D8D8D"
					/>
					<path
						d="M205.02 684.977C217.741 684.977 228.039 676.321 228.039 665.628C228.039 654.935 217.741 646.268 205.02 646.268C192.311 646.268 181.988 654.935 181.988 665.628C181.988 676.321 192.311 684.977 205.02 684.977Z"
						fill="white"
					/>
					<path
						d="M271.888 684.977C284.609 684.977 294.92 676.321 294.92 665.628C294.92 654.935 284.609 646.268 271.888 646.268C259.18 646.268 248.857 654.935 248.857 665.628C248.857 676.321 259.18 684.977 271.888 684.977Z"
						fill="white"
					/>
					<path
						d="M338.856 684.977C351.577 684.977 361.887 676.321 361.887 665.628C361.887 654.935 351.577 646.268 338.856 646.268C326.147 646.268 315.837 654.935 315.837 665.628C315.837 676.321 326.147 684.977 338.856 684.977Z"
						fill="white"
					/>
					<path
						d="M1184.02 1155.93C1222.9 1143.21 1333.48 1082.71 1297.05 1044.85C1260.62 1006.99 1144.63 1020.26 1138.73 1035.04C1131.29 1053.81 1215.32 1039.68 1230.33 1002.04C1245.35 964.399 1127.44 992.435 1116.67 964.835C1107.94 942.4 1179.39 916.306 1179.53 874.137"
						stroke="#231F20"
						strokeWidth="4"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M1557.19 787.086C1628.36 787.086 1686.06 738.577 1686.06 678.753C1686.06 618.928 1628.36 570.43 1557.19 570.43C1486.01 570.43 1428.31 618.928 1428.31 678.753C1428.31 738.577 1486.01 787.086 1557.19 787.086Z"
						fill="#61CCFF"
					/>
					<path
						d="M1603.01 664.339L1550.49 636.552C1537.1 629.34 1519.52 637.601 1519.52 650.976V706.54C1519.52 719.903 1537.1 727.999 1550.49 720.963L1603.01 693.176C1615.56 686.494 1615.56 671.021 1603.01 664.339Z"
						fill="#231F20"
					/>
					<path
						d="M508.606 775.489H485.129L480.74 763.995C477.39 755.318 467.846 749.457 457.264 749.457H405.923C395.081 749.457 385.796 755.318 382.446 763.995L378.058 775.489H354.581C327.223 775.489 305.292 794.142 305.292 816.91V896.718C305.292 919.714 327.483 938.149 354.581 938.149H508.865C536.211 938.149 558.142 919.496 558.142 896.718V816.91C557.882 794.142 535.692 775.489 508.606 775.489ZM434.047 886.097C412.623 886.097 395.34 871.559 395.34 853.561C395.34 835.563 412.623 821.035 434.047 821.035C455.459 821.035 472.742 835.563 472.742 853.561C472.742 871.559 455.459 886.097 434.047 886.097Z"
						fill="black"
					/>
					<path
						d="M1331.61 983.228L1325.14 951.596L1349.12 977.097L1367.73 948.219L1365.97 981.212L1397.64 979.155L1367.14 996.613L1390.99 1024.46L1355.71 1012.79L1343.11 1045.5L1336.16 1009.31L1308.98 1025.64L1325.37 999.065L1295.63 981.753L1331.61 983.228Z"
						fill="#FFC930"
					/>
					<path
						d="M1566.09 1063.44L1522 1036.17L1546.67 1078.09L1500.13 1098.78L1553.84 1098.06L1547.38 1124.83L1570.06 1104.37L1586.45 1141.93L1591.47 1101.83L1648.28 1120.21L1598.99 1088.15L1651.49 1063.59L1592.34 1067.8L1598.94 1028.53L1566.09 1063.44Z"
						fill="#FFC930"
					/>
					<path
						d="M368.687 492.544C380.58 492.544 390.198 500.639 390.198 510.626C390.198 520.612 380.58 528.707 368.687 528.707C356.806 528.707 347.176 520.612 347.176 510.626C347.176 500.639 356.806 492.544 368.687 492.544Z"
						fill="#FFC930"
					/>
					<path
						d="M1651.77 293.024C1663.65 293.024 1673.28 301.119 1673.28 311.106C1673.28 321.092 1663.65 329.187 1651.77 329.187C1639.89 329.187 1630.26 321.092 1630.26 311.106C1630.26 301.119 1639.89 293.024 1651.77 293.024Z"
						fill="white"
					/>
					<path
						d="M1429.92 234L1445.65 296.942L1395.08 255.968L1276.66 299.883L1358.55 228.107L1302.78 175.432L1384.67 191.498L1428.23 113.924L1423.02 193.025L1504.91 179.807L1429.92 234Z"
						stroke="#FFC930"
						strokeWidth="4"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M646.089 721.389L646.027 418.836C646.027 399.84 664.41 384.336 687.046 384.315H1272.98C1295.57 384.357 1313.96 399.85 1313.97 418.836V721.389H646.089Z"
						fill="white"
					/>
					<path
						d="M736.483 556.817C723.416 556.817 712.76 547.869 712.76 536.885V346.25C712.76 335.235 723.392 326.319 736.459 326.319H965.684C978.739 326.319 989.371 335.235 989.395 346.23V536.885C989.395 547.869 978.764 556.817 965.684 556.817H736.483ZM736.483 334.456C728.782 334.477 722.514 339.756 722.489 346.23V536.885C722.489 543.359 728.782 548.649 736.483 548.67H965.684C973.398 548.649 979.691 543.38 979.716 536.885V346.25C979.691 339.756 973.398 334.456 965.684 334.456H736.483Z"
						fill="white"
					/>
					<path
						d="M1100.4 778.45C1087.33 778.45 1076.69 769.503 1076.69 758.519V567.863C1076.69 556.869 1087.33 547.932 1100.4 547.932H1328.44C1341.5 547.932 1352.14 556.869 1352.14 567.863V758.519C1352.14 769.503 1341.5 778.45 1328.44 778.45H1100.4ZM1100.4 556.068C1092.67 556.068 1086.38 561.368 1086.38 567.863V758.519C1086.38 765.014 1092.67 770.282 1100.4 770.303H1328.44C1336.16 770.282 1342.46 765.014 1342.46 758.519V567.863C1342.46 561.368 1336.16 556.068 1328.44 556.068H1100.4Z"
						fill="white"
					/>
					<path
						d="M614.874 757.501C601.806 757.501 591.162 748.553 591.162 737.569V615.27C591.162 604.286 601.806 595.349 614.874 595.349H744.482C757.549 595.349 768.181 604.286 768.181 615.27V737.569C768.181 748.553 757.549 757.501 744.482 757.501H614.874ZM614.874 603.486C607.147 603.486 600.854 608.775 600.854 615.27V737.569C600.854 744.064 607.147 749.333 614.874 749.353H744.482C752.184 749.333 758.476 744.064 758.501 737.569V615.27C758.476 608.775 752.184 603.486 744.482 603.486H614.874Z"
						fill="white"
					/>
					<path d="M747.387 475.44L747.313 353.4L954.694 353.348L954.743 475.44H747.387Z" fill="white" />
					<path
						d="M750.231 514.533C746.262 510.906 746.262 505.471 750.231 501.845C752.32 499.912 755.324 498.81 758.427 498.81C761.246 498.81 763.916 499.673 765.993 501.284L768.379 503.289L770.666 501.284C772.767 499.517 775.549 498.53 778.541 498.53C781.52 498.53 784.302 499.517 786.428 501.284C790.742 504.931 790.743 510.886 786.403 514.533L768.329 529.746L750.231 514.533Z"
						fill="white"
					/>
					<path
						d="M807.271 949.777C798.333 949.777 791.076 943.667 791.076 936.164C791.076 928.651 798.333 922.551 807.271 922.551H871.667L871.606 792.905C871.606 771.508 892.3 754.102 917.755 754.102H1042.21C1067.65 754.102 1088.36 771.508 1088.36 792.905V911.006C1088.33 932.371 1067.63 949.777 1042.21 949.777H807.271Z"
						fill="#3C2C5B"
					/>
					<path
						d="M654.273 837.485C611.585 837.485 576.859 808.295 576.859 772.413V391.319C576.908 355.468 611.635 326.319 654.273 326.319H1305.75C1348.37 326.34 1383.09 355.489 1383.14 391.319V772.413C1383.14 808.295 1348.41 837.485 1305.73 837.485H654.273ZM687.095 384.44C664.534 384.44 646.163 399.871 646.163 418.836V721.327L1313.91 721.265L1313.97 418.836C1313.97 399.871 1295.59 384.44 1273.03 384.44H687.095Z"
						fill="#3C2C5B"
					/>
					<path
						d="M980.025 803.608C964.114 803.608 951.171 792.718 951.171 779.344C951.171 765.98 964.114 755.09 980.025 755.09C995.935 755.09 1008.88 765.98 1008.88 779.344C1008.88 792.718 995.935 803.608 980.025 803.608Z"
						fill="#61CCFF"
					/>
					<path
						d="M980.025 363.126C974.919 363.126 970.741 359.614 970.741 355.333C970.741 351.02 974.919 347.528 980.025 347.528C985.13 347.528 989.297 351.02 989.297 355.333C989.297 359.614 985.13 363.126 980.025 363.126Z"
						fill="black"
					/>
					<path d="M1088.28 837.651H871.247" stroke="black" strokeWidth="4" />
				</g>
				<defs>
					<clipPath id="clip0_8_2">
						<rect width="1978" height="1247" fill="white" transform="translate(-9)" />
					</clipPath>
				</defs>
			</svg>

			<h1 className=" text-[3.5rem] font-cairo font-bold mt-8">التخصصات</h1>

			<div className="flex flex-col place-content-around my-16 lg:flex-row">
				<div className="flex flex-col place-content-center my-8">
					<div>
						<FontAwesomeIcon icon={faImagePortrait} style={{ color: "#000000", height: "75px" }} />
					</div>
					<h2 className="text-3xl font-cairo font-bold">صور شخصية</h2>
					<p className="text-xl place-self-center mt-3 w-[250px]">
						صورت للعديد من الأشخاص صور اظهرت ملامحهم, وادت لهم الرسالة التي هي مشاعرهم وما عرفت لي غير راضٍ بتصوري
					</p>
				</div>
				<div className="flex flex-col place-content-center my-8">
					<div>
						<FontAwesomeIcon icon={faCalendar} style={{ color: "#000000", height: "75px" }} />
					</div>
					<h2 className="text-3xl font-cairo font-bold">فعاليات</h2>
					<p className="text-xl place-self-center mt-3 w-[250px]">
						لحبي البهجة السرور, اصور الفعاليات والمناسبات لألطقت البشوش والبهجة بين الناس وانشر ما لقيته من سعادة مع غيري
					</p>
				</div>
				<div className="flex flex-col place-content-center my-8">
					<div>
						<FontAwesomeIcon icon={faLeaf} style={{ color: "#000000", height: "75px" }} />
					</div>
					<h2 className="text-3xl font-cairo font-bold">المناظر الطبيعية</h2>
					<p className="text-xl place-self-center mt-3 w-[250px]">
						لا اجمل ولا الين للقلب من النظر لخلق الله والتفكر فيه, فمن ما احببيت ان احتفظ به واشاركه مع غيري الصور الطبيعية الخلابة
					</p>
				</div>
			</div>
			<Link className="" to="/contact">
				<button className=" bg-zinc-600 text-2xl text-white font-cairo font-bold rounded-md px-6 py-2">تواصل</button>
			</Link>
		</section>
	);
};

export default Services;
